import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import PostLoginLayout from "../components/layouts/PostLoginLayout";
import ManagePlatFormsComponent from "../components/ManagePlatformsComponent";

const ManagePlatforms = () => {
  const location = useLocation();
  const stateObj = location.state;

  let ManagePlatformsContainer = <ManagePlatFormsComponent data={stateObj} />;

  return <PostLoginLayout childComponent={ManagePlatformsContainer} noLeftPanel={true} loader={false}/>;
};

export default ManagePlatforms;
